import ApiService from '@/services/api.service';
import {
  AuthError, PMSError, TooManyAttemptsError, ValidationError,
} from '@/errors';
import { apiEndpoint } from '@/shared';

function handleApiError(error) {
  const { status, data } = error.response;
  const rlr = error.response.headers['x-ratelimit-reset'] || 0;
  switch (status) {
    case 401:
      // TODO: remove user from storage?
      return new AuthError(status, data.message);
    case 409: // PMSError
      return new PMSError(status, data.message);
    case 422:
      return new ValidationError(status, data.message, data.errors);
    case 429:
      return new TooManyAttemptsError(rlr ? data.message : data.errors.email[0], rlr);
    default:
      return error;
  }
}

const PerformanceMeasureService = {

  async storeData(payload) {
    try {
      // save loading performance measuring data into table
      // eslint-disable-next-line no-param-reassign
      payload = { ...payload, ...{ type: 2 } };
      return await ApiService.post(`${apiEndpoint}/reports`, payload);
    } catch (error) {
      throw handleApiError(error);
    }
  },

};

export default PerformanceMeasureService;
